import React from "react";
import Login from "./component/login/login";
import { BrowserRouter, Switch, withRouter, Route } from "react-router-dom";
import Dashboard from "./component/dashboard/dashboard";
import PrivateRoute from "./component/router/privateRoute";
import PublicRoute from "./component/router/publicRoute";
import ErrorPage from "./component/errorPage/errorpage";
import dotenv from "dotenv";
var dotenvExpand = require("dotenv-expand");

//Environment Variable
var myEnv = dotenv.config();
dotenvExpand.expand(myEnv);

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute exact path="/" component={Dashboard}></PrivateRoute>
        <PrivateRoute
          exact
          path="/dashboard"
          component={Dashboard}
        ></PrivateRoute>
        <PublicRoute exact path="/login" component={Login}></PublicRoute>
        <PrivateRoute exact path="/page/:id" component={Dashboard} />
        <PrivateRoute exact path="/normalpage/:id" component={Dashboard} />
        <PrivateRoute exact path="/articlepage/:id" component={Dashboard} />
        <PrivateRoute exact path="/textpage/:id" component={Dashboard} />
        <PrivateRoute exact path="/seasonpage/:id" component={Dashboard} />
        <PrivateRoute exact path="/externalpage/:id" component={Dashboard} />
        <PrivateRoute exact path="/internalpage/:id" component={Dashboard} />
        <PrivateRoute exact path="/videopage/:id" component={Dashboard} />
        <PrivateRoute exact path="/livepage/:id" component={Dashboard} />
        <PrivateRoute exact path="/listpage/:id" component={Dashboard} />
        <PrivateRoute exact path="/epgdetail" component={Dashboard} />
        <PrivateRoute exact path="/tab/:id" component={Dashboard} />
        <PrivateRoute exact path="/textGrid/:id" component={Dashboard} />
        <PrivateRoute exact path="/menu/:id" component={Dashboard} />
        <PrivateRoute
          exact
          path="/highlightTextGrid/:id"
          component={Dashboard}
        />
        <PrivateRoute exact path="/epg/:id" component={Dashboard} />
        <PrivateRoute exact path="/item/gallery/:id" component={Dashboard} />
        <PrivateRoute exact path="/embed/:id" component={Dashboard} />
        <PrivateRoute exact path="/item/:type/:id" component={Dashboard} />
        <PrivateRoute exact path="/ticker/:id" component={Dashboard} />
        <PrivateRoute exact path="/tickers" component={Dashboard} />
        <PrivateRoute exact path="/vcms" component={Dashboard} />
        <PrivateRoute exact path="/live" component={Dashboard} />
        <PrivateRoute exact path="/colors" component={Dashboard} />
        <PrivateRoute exact path="/branding" component={Dashboard} />
        <PrivateRoute exact path="/menu" component={Dashboard} />
        <PrivateRoute exact path="/pages" component={Dashboard} />
        <PrivateRoute exact path="/users" component={Dashboard} />
        <PrivateRoute exact path="/changepassword" component={Dashboard} />
        <PrivateRoute exact path="/passwordchange" component={Dashboard} />
        <PrivateRoute exact path="/elements" component={Dashboard} />
        <PrivateRoute exact path="/images" component={Dashboard} />
        <PrivateRoute exact path="/setting" component={Dashboard} />
        <PrivateRoute exact path="/websetting" component={Dashboard} />
        <PrivateRoute exact path="/appsetting" component={Dashboard} />
        <PrivateRoute exact path="/adTag" component={Dashboard} />
        <PrivateRoute exact path="/analytics" component={Dashboard} />
        <PrivateRoute exact path="/files" component={Dashboard} />
        <PrivateRoute exact path="/footer" component={Dashboard} />
        <PrivateRoute exact path="/profile" component={Dashboard} />
        <PrivateRoute exact path="/fonts" component={Dashboard} />
        <PrivateRoute exact path="/subscription" component={Dashboard} />
        <PrivateRoute exact path="/videoreport" component={Dashboard} />
        <PrivateRoute exact path="/videodetails" component={Dashboard} />
        <PrivateRoute exact path="/subscriptionreport" component={Dashboard} />
        <PrivateRoute exact path="/analyticreport" component={Dashboard} />
        <PrivateRoute exact path="/language" component={Dashboard} />
        <PrivateRoute exact path="/log" component={Dashboard} />
        <PrivateRoute exact path="/notification" component={Dashboard} />
        <PrivateRoute exact path="/error" component={Dashboard} />
        <Route
          exact
          path=""
          render={(props) => <ErrorPage {...props} code={"404"} />}
        ></Route>
      </Switch>
    </BrowserRouter>
  );
};
export default withRouter(App);
